import { render } from "./MdTableAlternateHeader.vue?vue&type=template&id=f850f450"
import script from "./MdTableAlternateHeader.vue?vue&type=script&lang=js"
export * from "./MdTableAlternateHeader.vue?vue&type=script&lang=js"

import "./MdTableAlternateHeader.vue?vue&type=style&index=0&id=f850f450&lang=scss"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.41_vue@3.5.14_typescript@5.5.4__webpack@5.99.8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__